import './App.css';
import RegForm from './components/RegForm';
import Upload from './components/Upload';
import { BrowserRouter as Router, Navigate, Route, Routes, Link } from 'react-router-dom';

import CorporateComponent from './components/Corporate';
import FundAccount from './components/FundAccount';
import Home from './components/Home';

function App() {

  return (
    <div className="App">
      
  
      <Routes>
        <Route path='/' element={<Home/>}>
        </Route>
        <Route path='/registration' element={<RegForm />}>
        </Route>
        <Route path='/fund-account' element={<FundAccount />}>
        </Route>
        <Route path='/corporate-registration' element={<CorporateComponent />}>
        </Route>
   
        <Route path='/upload' element={<Upload />}>
        </Route>
        <Route path='/home' element={<Home />}>
        </Route>
        <Route path='*' element={<Navigate to="/" />}>
        </Route>
      </Routes>
    </div>
   
  );
}

export default App;
